"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLocale = exports.withDefaults = exports.OIDCDefaultSettings = void 0;
exports.OIDCDefaultSettings = {
    authority: 'https://auth-qs.dc.gls-group.eu/auth/realms/gls',
    response_type: 'code',
    scope: 'openid',
    filterProtocolClaims: true,
    loadUserInfo: true,
    revokeAccessTokenOnSignout: false
};
const withDefaults = (settings) => {
    Object.assign(exports.OIDCDefaultSettings, settings);
};
exports.withDefaults = withDefaults;
const withLocale = (locale) => {
    Object.assign(exports.OIDCDefaultSettings, { ui_locales: locale });
};
exports.withLocale = withLocale;
//# sourceMappingURL=oidc-default-settings.js.map